module.exports = __webpack_public_path__ + "assets/categories_button-b4230a.svg";